import React from "react";

// variante: "primario" (ação principal), "secundario" (contorno), "texto" (link discreto).
// tamanho: "md" ou "lg" (barra fixa / ação do diálogo).
const Botao = ({
  variante = "primario",
  tamanho = "md",
  largo = false,
  icone,
  carregando = false,
  type = "button",
  className = "",
  disabled,
  children,
  ...resto
}) => {
  const classes = [
    "gm-botao",
    `gm-botao--${variante}`,
    `gm-botao--${tamanho}`,
    largo && "gm-botao--largo",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button type={type} className={classes} disabled={disabled || carregando} aria-busy={carregando || undefined} {...resto}>
      {icone && <span className="gm-botao__icone" aria-hidden="true">{icone}</span>}
      {children}
    </button>
  );
};

export default Botao;
